import Styled from 'styled-components'

export const Container = Styled.div`
`
export const ContainerContent = Styled.div`
`

export const Passenger = Styled.h2`
`

export const ContentButton = Styled.div`
`

export const P = Styled.p`
`


export const ButtonQtd = Styled.button`
`
export const ContainerPlusMinus = Styled.div`
`

export const ContainerGrid = Styled.div`
`